import React from "react";
import siteLogo from "../../../assets/images/Dancebrite_Primary_Logo-No_BG.png";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import useForm from "../../../hooks/useForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { resetPasswordAccept } from "../../../services/authService";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

const validation = {
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  let token = searchParams.get("token");
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      password: "",
      confirmPassword: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await resetPasswordAccept({
        token: token,
        password: val?.password,
        status: 1,
      });
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        localStorage.clear();
        sessionStorage.clear();
        if (res?.data?.role?.toLowerCase() === "admin") {
          window.location.href = window.location.origin + "/admin";
        } else if (res?.data?.role?.toLowerCase() === "user") {
          window.location.href = window.location.origin + "/login";
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const navigate = useNavigate();
  const settings = useSelector((state) => state?.settings?.data);

  const handleClick = () => {
    navigate("/admin/forgot-password", {
      state: "admin",
    });
  };

  return (
    <div className="w-full min-h-screen bg-slate-50 flex items-center justify-center py-3 px-5">
      <div className="w-full max-w-md xl:max-w-md bg-white py-10 shadow-md rounded-2xl border border-red-700 ">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-12 w-auto"
              src={settings?.favicon?.url || siteLogo}
              alt="Your Company"
            />
            <h2 className="mt-1 uppercase text-center text-md font-bold leading-9 tracking-tight text-red-700">
              Reset Password
            </h2>
            <h2 className="mt-1 text-center text-base font-semibold leading-9 tracking-tight text-black">
              Authorized Personnel Only.
            </h2>
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={(event) => handleSubmit(event, mutate)}>
              <div className="mt-2">
                <Input
                  label={"Password"}
                  inputPlaceholder={"Enter Your Password"}
                  labelClasses={"!text-xs"}
                  inputType={"password"}
                  value={values.password}
                  inputName={"password"}
                  onChange={handleChange}
                  {...formValidate(errors, "password")}
                />
              </div>

              <div className="mt-2">
                <Input
                  label={"Confirm Password"}
                  inputPlaceholder={"Enter Confirm Password"}
                  labelClasses={"!text-xs"}
                  inputType={"password"}
                  value={values.confirmPassword}
                  inputName={"confirmPassword"}
                  onChange={handleChange}
                  {...formValidate(errors, "confirmPassword")}
                />
              </div>

              <div className="mt-2">
                <Button
                  loading={isLoading}
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonLabel={"Reset Password"}
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-light fa-right-to-bracket"}
                  buttonClasses={
                    "w-full !text-white !bg-primary !hover:bg-white !hover:text-primary focus-visible:outline justify-center rounded-md border border-primary"
                  }
                />
              </div>
              <div className="flex justify-end">
                <Button
                  buttonClasses={
                    "!justify-right !bg-transparent !text-slate-500 border-none"
                  }
                  buttonHasLink={false}
                  buttonType={"button"}
                  buttonLabel={"Forgot Password?"}
                  buttonFunction={handleClick}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
